import ConnectPaypal from './connect-paypal';
import Integrations from './integrations';
import MissedOrders from './missed-orders';
import OrderLayout from './order-layout';
import PaymentMethods from './payment-methods';
import Receipts from './receipts';
import ServiceFee from './service-fee';
import ProcessingFees from './processing-fees';
import StaffCredentials from './staff-credentials';
import Takeout from './takeout';
import Tips from './tips';
import Terminal from './terminal';
import Invoices from './Invoices';

export default {
  ConnectPaypal,
  Integrations,
  MissedOrders,
  OrderLayout,
  PaymentMethods,
  Receipts,
  ServiceFee,
  ProcessingFees,
  StaffCredentials,
  Takeout,
  Tips,
  Terminal,
  Invoices,
};
